import { Box, Flex, Group, Stack, Text } from '@mantine/core';

import { SIMULATION_STATUSES } from '../../config';
import { useSimulationFormContext, useSimulationStatus } from '../../hooks';
import { mapStatuses } from '../../utils';

export const PopoverContent = () => {
  const simulationStatus = useSimulationStatus();
  const status = simulationStatus.data?.status as SIMULATION_STATUSES;
  const { currentFormConfig } = useSimulationFormContext();

  const FormComponent = currentFormConfig?.component;

  return (
    <Box bg="white">
      <Stack gap="sm">
        <Group gap="sm">
          <Flex direction="column" gap="sm">
            <Text fw={600}>Application Status</Text>
            <Text>{mapStatuses(status)}</Text>
          </Flex>
          {FormComponent && <FormComponent />}
        </Group>
      </Stack>
    </Box>
  );
};
